let Backbone = require("backbone");
let _ = require("underscore");
import i18n from "../../utils/i18n";

let main = function (Backbone, _, i18n) {
    return Backbone.View.extend({
        validateMode: {},
        validateArgs: {},

        setElement : function(ele) {
            Backbone.View.prototype.setElement.call(this, ele);
            this.validateMode = {};
            this.validateArgs = {};
        },

        render: function () {
            if (!this.el) {
                return this;
            }

            if (this.validateMode['notEmpty']!=undefined && !this.validateMode['notEmpty']) {
                this.$el.closest('.form-group').addClass('has-error').find('.help-block').text(
                    i18n.msg('pos.validation.notEmpty'));
            }

            if (this.validateMode['requireSelection']!=undefined && !this.validateMode['requireSelection']) {
                this.$el.closest('.form-group').addClass('has-error').find('.help-block').text(
                    i18n.msg('pos.validation.requireSelection'));
            }

            if (this.validateMode['tlessThan']!=undefined && !this.validateMode['tlessThan']) {
                this.$el.closest('.form-group').addClass('has-error').find('.help-block').text(
                    i18n.msg('pos.validation.lessThan', this.validateArgs['tlessThan']));
            }

            if (this.validateMode['ge']!=undefined && !this.validateMode['ge']) {
                this.$el.closest('.form-group').addClass('has-error').find('.help-block').text(
                    i18n.msg('pos.validation.greaterThan', this.validateArgs['ge']));
            }

            if (this.validateMode['equal']!=undefined && !this.validateMode['equal']) {
                this.$el.closest('.form-group').addClass('has-error').find('.help-block').text(
                    i18n.msg('pos.validation.equal', this.validateArgs['equal']));
            }

            if (this.validateMode['excludeHTML']!=undefined && !this.validateMode['excludeHTML']) {
                this.$el.closest('.form-group').addClass('has-error').find('.help-block').text(
                    i18n.msg('pos.validation.excludeHTML', this.validateArgs['excludeHTML']));
            }

            return this;
        },

        notEmpty: function () {
            this.validateMode['notEmpty'] = this.$el.val().trim().length != 0;
            return this;
        },

        excludeHTML: function () {
            var val = this.$el.val().trim();
            this.validateMode['excludeHTML'] = ((val == null) || (val.indexOf("<") < 0 && val.indexOf(">") < 0));
            return this;
        },

        textLessThan: function(number) {
            this.validateMode['tlessThan'] = this.$el.val().trim().length < number;
            this.validateArgs['tlessThan'] = number;
            return this;
        },

        ge: function(number) {
            this.validateMode['ge'] = (this.$el.val().trim()=="" || !_.isNumber(number)) ? false :
                this.validateMode['ge'] = this.$el.val().trim() >= number;
            this.validateArgs['ge'] = {number: number};
            return this;
        },

        lessThan: function(number) {
            this.validateMode['lessThan'] = (this.$el.val().trim()=="" || !_.isNumber(number)) ? false :
                this.validateMode['lessThan'] = this.$el.val().trim() < number;
            this.validateArgs['lessThan'] = {number: number};
            return this;
        },

        textEqual: function(number) {
            this.validateMode['equal'] = this.$el.val().trim().length == number;
            this.validateArgs['equal'] = number;
            return this;
        },

        requireSelection: function() {
            var values = [];
            this.$el.each(function(i, item) {
                values.push($(item).prop('checked'));
            });

            this.validateMode['requireSelection'] = _.every(values, function(item) {return item});
            return this;
        },

        isValid: function () {
            return _.every(_.values(this.validateMode), function (item) {
                return item
            });
        }
    });
};

let exportedValue = main(Backbone, _, i18n);
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/comp/ValidationView.js